/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import Timeago from "react-timeago";
import get from "lodash.get";
import { useStateValue } from "../../SharedContext";
import { formatter, getTextColor } from "../../../utils/utils";

import PropTypes from "prop-types";

import "./timestamp.m.css";

export const TimeStamp = ({ story, isBottom }) => {
  const config = useStateValue() || {};
  const isTime = get(config, ["showTime"], true);

  const time = story["last-published-at"] || story["first-published-at"];
  const isBottomClasses = isBottom ? "bottom-fix" : "";
  const textColor = getTextColor(config.theme);
  return (
    <>
      {isTime && (
        <div className="time arr--publish-time" styleName={`time  ${textColor} ${isBottomClasses}`}>
          <div styleName="time-wrapper">
            <Timeago date={time} formatter={formatter} />
          </div>
        </div>
      )}
    </>
  );
};

TimeStamp.propTypes = {
  /** The Story Object from the API response */
  story: PropTypes.object,
  isBottom: PropTypes.bool
};
